// extracted by mini-css-extract-plugin
module.exports = {"root":"Histogram_root__1EN7H","title":"Histogram_title__1pk8p","line":"Histogram_line__1HuCJ","legend":"Histogram_legend__2wIry"};